export const chartDays = [
  {
    label: "1 Day",
    value: 1,
  },
  {
    label: "1 Month",
    value: 30,
  },
  {
    label: "6 Months",
    value: 180,
  },
  {
    label: "1 Year",
    value: 365,
  },
];
